import React from "react";

const MarriedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <circle cx="18" cy="19.125" r="6.75" fill="#EDECF7" />
    <rect
      x="9.22461"
      y="6.86255"
      width="3.375"
      height="1.125"
      fill="url(#paint0_linear_7036_4369)"
    />
    <path
      d="M7.48633 15.0967L18.0219 6.86539L19.0906 8.23327L9.11727 15.728L8.60404 15.6546L7.48633 15.0967Z"
      fill="url(#paint1_linear_7036_4369)"
    />
    <path
      d="M18.3633 7.33984L27.9804 14.8536L25.8704 15.5525L17.722 9.48992L17.7838 8.87819L18.3633 7.33984Z"
      fill="url(#paint2_linear_7036_4369)"
    />
    <rect
      x="6.75"
      y="27.675"
      width="22.5"
      height="1.125"
      fill="url(#paint3_linear_7036_4369)"
    />
    <mask
      id="mask0_7036_4369"
      maskUnits="userSpaceOnUse"
      x="6"
      y="6"
      width="24"
      height="24"
    >
      <path
        d="M6.33984 6.34009H29.4688V29.4734H6.33984V6.34009Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_7036_4369)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.6873 28.6927H7.11585V27.9223H28.6873V28.6927ZM10.051 13.4539C10.051 13.4539 10.0515 13.4534 10.0519 13.4534L12.3631 11.6203L17.907 7.22339L27.9274 14.825H26.1143L18.1255 9.11852C17.9884 9.02075 17.8023 9.02342 17.6682 9.12593L9.6826 15.2102H7.83632L10.051 13.4539ZM9.42712 7.12118H12.5087V7.89157H9.42712V7.12118ZM19.0675 23.8996C19.1145 23.692 19.3214 23.5618 19.5282 23.6088C19.7517 23.6596 19.982 23.685 20.2128 23.685C21.9119 23.685 23.2944 22.3026 23.2944 20.6034C23.2944 19.1192 22.1835 17.8095 20.7185 17.5676C20.1985 17.4817 19.6589 17.5299 19.1631 17.7098C17.9801 18.1404 17.1311 19.2733 17.1311 20.6034C17.1311 21.0845 17.239 21.5452 17.4513 21.9728C17.546 22.1635 17.4682 22.3946 17.2775 22.4894C17.0868 22.5845 16.8561 22.5059 16.7613 22.3157C16.4955 21.7806 16.3607 21.2044 16.3607 20.6034C16.3607 19.1242 17.2001 17.8388 18.4262 17.1937L17.9785 16.5963C17.8634 16.4429 17.8788 16.2284 18.0144 16.0928L18.7848 15.3232C18.8573 15.2511 18.9551 15.2107 19.0572 15.2107H21.3684C21.4704 15.2107 21.5687 15.2511 21.6407 15.3235L22.4111 16.0939C22.5467 16.23 22.5621 16.4444 22.4469 16.5977L21.9997 17.1941C23.2259 17.8393 24.0647 19.1243 24.0647 20.6035C24.0647 22.7275 22.3368 24.4556 20.2126 24.4556C19.9245 24.4556 19.6371 24.4236 19.3579 24.3601C19.1506 24.3135 19.0206 24.1069 19.0675 23.8996ZM15.5904 23.685C17.2896 23.685 18.672 22.3026 18.672 20.6034C18.672 20.1223 18.5642 19.6616 18.352 19.234C18.2571 19.0433 18.335 18.8123 18.5257 18.7174C18.7163 18.6223 18.9471 18.7013 19.0419 18.8912C19.3076 19.4263 19.4424 20.0026 19.4424 20.6034C19.4424 22.7275 17.7145 24.4555 15.5903 24.4555C13.4661 24.4555 11.7382 22.7276 11.7382 20.6034C11.7382 18.4793 13.4661 16.7513 15.5903 16.7513C16.031 16.7513 16.4632 16.8253 16.8749 16.9709C17.0752 17.0417 17.1804 17.262 17.1095 17.4623C17.0383 17.6631 16.8183 17.7683 16.6181 17.6973C16.289 17.5806 15.9431 17.5217 15.5903 17.5217C13.8911 17.5217 12.5087 18.9041 12.5087 20.6033C12.5087 22.3025 13.8912 23.685 15.5904 23.685ZM29.0727 27.1519H27.1467V15.5958H29.0727C29.238 15.5958 29.3851 15.4903 29.4379 15.3335C29.4906 15.1768 29.4371 15.0038 29.3054 14.9037L18.1346 6.42924C17.9951 6.32369 17.8006 6.32515 17.6622 6.43422L12.5092 10.5217V8.66232H12.8943C13.107 8.66232 13.2796 8.48973 13.2796 8.27704V6.73622C13.2796 6.52368 13.107 6.35107 12.8943 6.35107H9.0422C8.82953 6.35107 8.65705 6.52367 8.65705 6.73622V8.27704C8.65705 8.48972 8.82952 8.66232 9.0422 8.66232H9.42748V12.9659L6.49135 15.2941C6.36309 15.3962 6.31342 15.568 6.36734 15.7229C6.42127 15.8777 6.56726 15.9813 6.73098 15.9813H8.65704V27.1522H6.73098C6.51831 27.1522 6.3457 27.3248 6.3457 27.5373V29.0783C6.3457 29.2908 6.51829 29.4634 6.73098 29.4634H29.0729C29.2856 29.4634 29.4582 29.2908 29.4582 29.0783V27.5373C29.4582 27.3248 29.2854 27.1519 29.0727 27.1519Z"
        fill="url(#paint4_linear_7036_4369)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7036_4369"
        x1="9.00523"
        y1="8.32505"
        x2="11.5142"
        y2="5.70705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5784F8" />
        <stop offset="1" stop-color="#F5B6FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7036_4369"
        x1="8.19083"
        y1="17.41"
        x2="6.00395"
        y2="10.4868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5784F8" />
        <stop offset="1" stop-color="#F5B6FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7036_4369"
        x1="16.0661"
        y1="8.99156"
        x2="23.6005"
        y2="5.34999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5784F8" />
        <stop offset="1" stop-color="#F5B6FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7036_4369"
        x1="5.2875"
        y1="29.1375"
        x2="5.9949"
        y2="24.2167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5784F8" />
        <stop offset="1" stop-color="#F5B6FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7036_4369"
        x1="4.84339"
        y1="36.3971"
        x2="36.8596"
        y2="25.2614"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5784F8" />
        <stop offset="1" stop-color="#F5B6FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default MarriedIcon;
